var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('v-scroll-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('ConfirmResolver'),_c('NotificationResolver')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }